export const memberBlockedSchemas: string[] = [
  'ListSubscription',
  'GetLowBalanceAlert',
  'CheckConfigurationAndRewardOfChannel',
  'liveConferences',
  'CustomerBillingAddress',
  'InvoicesV2',
  'GetAutoRechargeConfigs',
  'availablePhoneNumbers',
];

export const suspendedAccountEnabledRoutes: string[] = [
  'authMe',
  'workspaceAuthMeV2',
  'ListPaymentSource',
  'EstimateRenewFailedSubscriptionV2',
  'ActiveWorkspacesV2',
];
